module.exports = __webpack_public_path__ + "static/media/feature-guarantee.1bc9157f.svg";